"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _stylingUtils = require("../../services/stylingUtils");

var _RheIcon = _interopRequireDefault(require("../RheIcon"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var Button =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Button, _React$Component);

  function Button() {
    var _this;

    _classCallCheck(this, Button);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Button).call(this));
    _this.state = {
      focus: false,
      iconBackgroundColor: '',
      iconForegroundColor: ''
    };
    _this._setFocus = _this._setFocus.bind(_assertThisInitialized(_assertThisInitialized(_this)));
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setState({
        iconBackgroundColor: this.props.iconBackgroundColor,
        iconForegroundColor: this.props.iconForegroundColor
      });
    }
  }, {
    key: "_setFocus",
    value: function _setFocus(isFocussed) {
      var _this2 = this;

      this.setState({
        focus: isFocussed
      }, function () {
        return _this2._determineIconColor();
      });
    }
  }, {
    key: "_getClassNames",
    value: function _getClassNames() {
      return (0, _stylingUtils.getClassNames)(this.props.className, {
        'rhe-button': true,
        'rhe-button__primary': !this.props.isSecondary,
        'rhe-button__secondary': this.props.isSecondary,
        'rhe-button__inverted': this.props.isInverted,
        'rhe-button__has-icon': this.props.icon,
        'rhe-button__link': this.props.isLink,
        'rhe-button__link-underlined': this.props.isUnderlined,
        'danger': this.props.theme === 'danger',
        'success': this.props.theme === 'success',
        'info': this.props.theme === 'info',
        'warning': this.props.theme === 'warning',
        'cancel': this.props.theme === 'cancel',
        'small': this.props.size === 'small',
        'medium': this.props.size === 'medium',
        'long': this.props.size === 'long'
      });
    }
  }, {
    key: "_determineIconColor",
    value: function _determineIconColor() {
      if (!this.props.isSecondary) {
        if (this.props.isInverted) {
          if (this.state.focus) {
            this.setState({
              iconBackgroundColor: this.props.iconForegroundColor,
              iconForegroundColor: this.props.iconBackgroundColor
            });
          } else {
            this.setState({
              iconBackgroundColor: this.props.iconBackgroundColor,
              iconForegroundColor: this.props.iconForegroundColor
            });
          }
        } else {
          if (this.state.focus) {
            this.setState({
              iconBackgroundColor: this.props.iconForegroundColor,
              iconForegroundColor: this.props.iconBackgroundColor
            });
          } else {
            this.setState({
              iconBackgroundColor: this.props.iconBackgroundColor,
              iconForegroundColor: this.props.iconForegroundColor
            });
          }
        }
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          onClick = _this$props.onClick,
          iconBackgroundColor = _this$props.iconBackgroundColor,
          iconForegroundColor = _this$props.iconForegroundColor,
          icon = _this$props.icon,
          isSecondary = _this$props.isSecondary,
          isInverted = _this$props.isInverted,
          props = _objectWithoutProperties(_this$props, ["onClick", "iconBackgroundColor", "iconForegroundColor", "icon", "isSecondary", "isInverted"]);

      return _react.default.createElement("button", _extends({}, props, {
        onClick: onClick,
        className: this._getClassNames(),
        onFocus: function onFocus() {
          return _this3._setFocus(true);
        },
        onBlur: function onBlur() {
          return _this3._setFocus(false);
        }
      }), icon && _react.default.createElement(_RheIcon.default, {
        icon: icon,
        backgroundColor: isInverted ? this.state.iconForegroundColor : this.state.iconBackgroundColor,
        foregroundColor: isInverted ? this.state.iconBackgroundColor : this.state.iconForegroundColor
      }), this.props.children);
    }
  }]);

  return Button;
}(_react.default.Component);

exports.default = Button;
Button.defaultProps = {
  onClick: function onClick() {},
  type: "button",
  iconBackgroundColor: '#2D5AB4',
  iconForegroundColor: '#fff'
};
Button.propTypes = {
  className: _propTypes.default.string,
  theme: _propTypes.default.oneOf(["danger", "cancel", "success", "info", "warning"]),
  size: _propTypes.default.oneOf(["small", "medium", "long"]),
  type: _propTypes.default.string,
  isSecondary: _propTypes.default.bool,
  isInverted: _propTypes.default.bool,
  isLink: _propTypes.default.bool,
  isUnderlined: _propTypes.default.bool,
  iconBackgroundColor: _propTypes.default.string,
  iconForegroundColor: _propTypes.default.string,
  onClick: _propTypes.default.func
};